import React from 'react';

export function Header({children}) {

  return <h3>{children}</h3>;

}